export const randomDigits = (length) => {
  return Math.floor(
    Math.pow(10, length - 1) + Math.random() * 9 * Math.pow(10, length - 1)
  );
};

// Regex for the date format that the API accepts. This format
// also takes into acount leap years and ensures the date is correct.
export const dateFormatRegex =
  /^(\d{4})-((0[1-9]|1[0-2])-(0[1-9]|1\d|2\d|30)|(0[13-9]|1[0-2])-(31)|02-(0[1-9]|1\d|2\d))$/i;

export const TRAPPING_MIN_YEAR = 2018;

export const HIGH_PRESSURE_THRESHOLDS_NUM = 5;

export const boostrapColourToHex = {
  primary: '#007bff',
  secondary: '#6c757d',
  success: '#28a745',
  danger: '#dc3545',
  warning: '#ffc107',
  info: '#17a2b8',
  light: '#f8f9fa',
  dark: '#343a40',
  white: '#ffffff'
};
